import './UploadFiles.css';
import trashIcon from './images/trash.svg';
import removeIcon from './images/remove.svg';
import jpgIcon from './images/jpg.png';
import pdfIcon from './images/pdf.png';
import { formatInTimeZone } from 'date-fns-tz';

export default function FileInformationCard({
  workOrderFiles,
  renderType,
  openImageModal,
  handleFileRemove,
  handleDisplayName,
  handleShowDeleteFileModal,
}) {
  const geoUrl = process.env.REACT_APP_GEOSERVER;

  return (
    <>
      {workOrderFiles.map((file, index) => (
        <div
          className="selected-file-container"
          style={{ cursor: renderType === 'uploaded' ? 'pointer' : '' }}
          key={index}
          onClick={
            file.extension === 'pdf' && renderType === 'uploaded'
              ? () =>
                  window.open(
                    `${geoUrl}/static/radninalozi/${file.folder}/${file.newName}`,
                    '_blank'
                  )
              : renderType === 'uploaded'
              ? () => openImageModal(file)
              : () => {}
          }
        >
          <div className="selected-file-type">
            <div
              className="selected-file-type-background"
              style={{
                backgroundColor:
                  file.type === 'application/pdf' || file.extension === 'pdf'
                    ? '#FFDCDC'
                    : '#c5f7c9',
              }}
            >
              <img
                src={
                  file.type === 'application/pdf' || file.extension === 'pdf'
                    ? pdfIcon
                    : jpgIcon
                }
                className="selected-file-type-icon"
                alt="Icon"
              />
            </div>
          </div>

          <div className="selected-file-name">
            {handleDisplayName(
              renderType === 'uploaded' ? file.originalName : file.name
            )}
          </div>
          <div className="selected-file-footer">
            <img
              src={renderType === 'uploaded' ? trashIcon : removeIcon}
              onClick={
                renderType === 'uploaded'
                  ? (e) => handleShowDeleteFileModal(e, file.id)
                  : () => handleFileRemove(index)
              }
              alt="Icon"
              width={renderType === 'uploaded' ? '14' : '12'}
              className="remove-selected-file "
            />
            <div className="selected-file-date">
              {formatInTimeZone(
                renderType === 'uploaded' ? file.uploadedAt : new Date(),
                'Europe/Paris',
                'dd.MM.yyyy.'
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
